(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clientes-vexial"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Cada fila se repite varias veces al cargar, para que el bucle
     (que corta al 33.3%, un tercio del recorrido) nunca deje ver un
     espacio vacío ni un salto, sin importar cuántos logos tenga esa
     fila puntual o qué tan ancha sea la pantalla. Se lee el HTML que
     Liquid ya renderizó (los logos reales, no una lista fija en JS) y
     se clona, en vez de reconstruir el contenido desde cero. */
  function buildLoop(track) {
    var original = track.innerHTML.trim();
    if (!original) return;
    track.innerHTML = original.repeat(6);
  }

  document.querySelectorAll('.vx-trust .vx-marquee-track').forEach(function (track) {
    buildLoop(track);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-vexial"] && !Shopify.designMode) return;
  try {
    
/* Conteos reales de la colección entera (Planos digitales, Producto
   físico, Formato, Precio, y el array para Tipo/Precio en el
   navegador) -- se piden acá, aparte del renderizado de Liquid, para
   no volver a chocar con la paginación de la grilla (ver comentario
   largo en la parte de arriba del archivo). */
(function () {
  var vxcFormatList = ['DXF', 'PDF', 'MP4', 'IGS', 'JPG', 'SVG', 'STL', 'STEP', 'DWG'];
  var currentTags = window.vxcCurrentTags || [];
  if (!window.vxcProductsFetchPromise) return;

  window.vxcProductsFetchPromise
    .then(function (data) {
      var products = data.products || [];

      /* Mismo criterio "Y" que usa Shopify para tags combinados en la URL */
      if (currentTags.length > 0) {
        products = products.filter(function (p) {
          var tagsUpper = (p.tags || []).map(function (t) { return t.toUpperCase(); });
          return currentTags.every(function (ct) { return tagsUpper.indexOf(ct.toUpperCase()) !== -1; });
        });
      }

      var counts = { planos: 0, fisico: 0, p1: 0, p2: 0, p3: 0, p4: 0 };
      vxcFormatList.forEach(function (f) { counts['fmt-' + f] = 0; });
      var allProducts = [];

      products.forEach(function (p) {
        var tags = p.tags || [];
        var tagsUpper = tags.map(function (t) { return t.toUpperCase(); });
        var isFisico = tags.some(function (t) { return t.toLowerCase() === 'producto-fisico'; });
        if (isFisico) { counts.fisico++; } else { counts.planos++; }

        vxcFormatList.forEach(function (f) {
          if (tagsUpper.indexOf(f) !== -1) counts['fmt-' + f]++;
        });

        var price = 0;
        if (p.variants && p.variants.length) price = parseFloat(p.variants[0].price) || 0;
        if (price <= 10) counts.p1++;
        else if (price <= 25) counts.p2++;
        else if (price <= 50) counts.p3++;
        else counts.p4++;

        allProducts.push({ f: isFisico, p: price });
      });

      window.vxcAllProducts = allProducts;

      document.querySelectorAll('.vxc-cnt').forEach(function (el) {
        var key = el.getAttribute('data-cnt-key');
        var n = counts[key];
        if (n !== undefined) el.textContent = '(' + n + ')';
      });

      if (counts.fisico > 0) {
        document.querySelectorAll('[data-reveal-key="fisico"]').forEach(function (el) { el.style.display = ''; });
      }

      var anyFormat = false;
      vxcFormatList.forEach(function (f) {
        if (counts['fmt-' + f] > 0) {
          anyFormat = true;
          document.querySelectorAll('[data-reveal-key="fmt-' + f + '"]').forEach(function (el) { el.style.display = ''; });
        }
      });
      if (anyFormat) {
        document.querySelectorAll('[data-reveal-key="any-format"]').forEach(function (el) { el.style.display = ''; });
      }

      /* Por si el usuario ya tenía Tipo/Precio activo (ej. volviendo con
         el botón atrás del navegador), recalcular con datos reales ya
         disponibles en vez de dejar el conteo aproximado de antes. */
      if (window.vxcApplyClientFilters) window.vxcApplyClientFilters();
      vxcHideSidebarSkeleton();
    })
    .catch(function (err) {
      console.error('VEXiAL: no se pudo cargar el conteo completo de la colección', err);
      vxcHideSidebarSkeleton();
    });

  function vxcHideSidebarSkeleton() {
    var skeleton = document.getElementById('vxcSidebarSkeleton');
    if (skeleton) skeleton.classList.add('is-done');
  }
})();

const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

(function() {

  function injectBadges() {
    var items = document.querySelectorAll('.product-grid__item[data-vxc-fisico]:not([data-vxc-injected])');
    if (!items.length) return;
    items.forEach(function(li) {
      li.setAttribute('data-vxc-injected', '1');
      var isFisico = li.getAttribute('data-vxc-fisico') === 'true';
      var formats  = li.getAttribute('data-vxc-formats') || '';
      var productId = li.getAttribute('data-product-id');

      /* ── 1. Badge Planos/Físico → overlay sobre imagen, arriba izquierda ── */
      var overlay = document.createElement('div');
      overlay.className = 'vxc-card-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      var badge = document.createElement('span');
      badge.className = 'vxc-badge ' + (isFisico ? 'vxc-badge--fisico' : 'vxc-badge--planos');
      badge.textContent = isFisico ? 'F\u00edsico' : 'Planos';
      overlay.appendChild(badge);
      li.appendChild(overlay);

      /* ── 2. Badges formato → overlay dentro del card-gallery, abajo izquierda ── */
      if (formats) {
        var fmtsDiv = document.createElement('div');
        fmtsDiv.className = 'vxc-formats';
        formats.split(',').forEach(function(fmt) {
          if (!fmt) return;
          var span = document.createElement('span');
          span.className = 'vxc-fmt vxc-fmt--' + fmt.toLowerCase();
          span.textContent = fmt;
          fmtsDiv.appendChild(span);
        });
        /* Insertar DENTRO del card-gallery — sobre la imagen, abajo izquierda */
        var cardGallery = li.querySelector('.card-gallery');
        if (cardGallery) {
          cardGallery.appendChild(fmtsDiv);
        } else {
          li.appendChild(fmtsDiv);
        }
      }

      /* ── 3. Judge.me → debajo de la imagen en el card content ── */
      if (productId) {
        var starsEl = document.createElement('div');
        starsEl.className = 'jdgm-widget jdgm-preview-badge vxc-stars-body';
        starsEl.setAttribute('data-id', productId);
        starsEl.setAttribute('data-judgeme-id', productId);
        var cardContent2 = li.querySelector('.product-card__content');
        var cardGallery2 = li.querySelector('.card-gallery');
        if (cardGallery2 && cardContent2) {
          cardContent2.insertBefore(starsEl, cardGallery2.nextSibling);
        } else {
          li.appendChild(starsEl);
        }
      }

      /* ── 4. Wishlist → overlay sobre imagen, arriba derecha.
         Usa el mismo localStorage (vxw_items) que la página de producto
         y el header, para que quede sincronizado en todos lados. */
      var vid = li.getAttribute('data-vxc-variant-id');
      if (vid) {
        var wishBtn = document.createElement('button');
        wishBtn.type = 'button';
        wishBtn.className = 'vxc-wish-btn';
        wishBtn.setAttribute('aria-label', 'A\u00f1adir a lista de deseos');
        wishBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

        var getWishItems = function () {
          try { return JSON.parse(localStorage.getItem('vxw_items') || '[]'); } catch (e) { return []; }
        };
        var isInWishlist = function () {
          var wItems = getWishItems();
          for (var wi = 0; wi < wItems.length; wi++) { if (String(wItems[wi].variantId) === String(vid)) return true; }
          return false;
        };
        var updateHeaderCount = function () {
          var count = getWishItems().length;
          document.querySelectorAll('.vx-wish-count').forEach(function (el) {
            el.textContent = count; el.style.display = count > 0 ? 'flex' : 'none';
          });
          if (window.vxSyncWishCount) window.vxSyncWishCount();
        };

        if (isInWishlist()) wishBtn.classList.add('is-active');

        wishBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var wItems = getWishItems();
          if (isInWishlist()) {
            wItems = wItems.filter(function (item) { return String(item.variantId) !== String(vid); });
            wishBtn.classList.remove('is-active');
          } else {
            wItems.push({
              variantId: vid,
              productId: productId,
              name: li.getAttribute('data-vxc-title') || '',
              variantName: '',
              image: li.getAttribute('data-vxc-image') || '',
              price: parseFloat(li.getAttribute('data-vxc-price')) || 0,
              currency: (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : '',
              handle: li.getAttribute('data-vxc-handle') || '',
              link: li.getAttribute('data-vxc-url') || '',
              addedOn: new Date().toISOString()
            });
            wishBtn.classList.add('is-active');
          }
          localStorage.setItem('vxw_items', JSON.stringify(wItems));
          updateHeaderCount();
        });

        li.appendChild(wishBtn);
      }
    });

    /* Si había un filtro de precio activo, aplicarlo también a las
       tarjetas recién cargadas (scroll infinito) */
    if (window.vxcApplyClientFilters) window.vxcApplyClientFilters();
  }

  /* Antes usaba requestIdleCallback para no atrasar la primera pintura,
     pero eso hacía que las etiquetas aparecieran notablemente después de
     las tarjetas. Se corre apenas termina de parsear el HTML en vez de
     esperar a que el navegador esté "libre" -- las tarjetas ya están en
     el DOM en este punto (este script corre después del HTML). */
  setTimeout(injectBadges, 0);

  /* MutationObserver con debounce para scroll infinito */
  var badgeTimer = null;
  var grid = document.querySelector('[ref="grid"]');
  if (grid && window.MutationObserver) {
    new MutationObserver(function() {
      clearTimeout(badgeTimer);
      badgeTimer = setTimeout(injectBadges, 100);
    }).observe(grid, { childList: true });
  }

  /* ── Quick-add fetch override ────────────────────────────────
     quick-add.js hace fetch a productPageUrl para obtener
     [data-product-grid-content]. Agregamos ?view=horizon para
     que Shopify renderice product.horizon.json — el template
     nativo con variant-picker y product-form-component.
     Solo afecta instancias dentro de .vxc-results. */
  customElements.whenDefined('quick-add-component').then(function() {
    var QuickAdd = customElements.get('quick-add-component');
    if (!QuickAdd) return;
    var proto = QuickAdd.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'productPageUrl');
    if (!descriptor || !descriptor.get) return;
    var originalGet = descriptor.get;
    Object.defineProperty(proto, 'productPageUrl', {
      get: function() {
        var url = originalGet.call(this);
        if (!url) return url;
        /* Solo modificar si el componente está dentro de nuestra sección */
        if (!this.closest('.vxc-results')) return url;
        try {
          var parsed = new URL(url, window.location.origin);
          parsed.searchParams.set('view', 'horizon');
          return parsed.toString();
        } catch(e) { return url; }
      },
      configurable: true
    });
  });

  /* ── Filtros: radio (tipo) + checkbox (formato/precio) ──────
     Radio → toggle: si ya está activo, limpiar; si no, navegar al tag
     Checkbox múltiple → combinar tags con + en la URL de Shopify     */
  (function() {
    var colUrl = window.location.pathname.split('/').slice(0, 3).join('/');

    /* Leer tags activos de la URL */
    function getActiveTags() {
      var parts = window.location.pathname.split('/');
      if (parts.length > 3) return parts[3].split('+');
      return [];
    }

    /* Construir URL con los tags dados */
    function buildUrl(tags) {
      var filtered = tags.filter(function(t) { return t && t.length > 0; });
      if (filtered.length === 0) return colUrl;
      return colUrl + '/' + filtered.join('+');
    }

    /* Checkbox múltiple: solo formato (sigue por tag/URL, sí existen esos tags) */
    document.querySelectorAll('input[data-tag]:not([name="vxc-price"])').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var activeTags = getActiveTags();
        var tag = cb.getAttribute('data-tag');
        if (cb.checked) {
          if (!activeTags.includes(tag)) activeTags.push(tag);
        } else {
          activeTags = activeTags.filter(function(t) { return t !== tag; });
        }
        window.location = buildUrl(activeTags);
      });
    });

    /* Tipo de producto y Precio: los dos son 100% del lado del cliente,
       sobre datos que cada tarjeta ya trae (data-vxc-fisico, data-vxc-price)
       -- no dependen de tags que no existen en los productos. Se combinan
       con lógica "Y": una tarjeta se muestra solo si pasa AMBOS filtros
       activos (si hay alguno activo). */
    window.vxcActiveFisico = null;   // null = sin filtro, true = solo físico, false = solo planos
    window.vxcActivePriceMin = null;
    window.vxcActivePriceMax = null;

    window.vxcApplyClientFilters = function () {
      var cards = document.querySelectorAll('.product-grid__item');
      var visibleCount = 0;
      cards.forEach(function (card) {
        var show = true;
        if (window.vxcActiveFisico !== null) {
          var isFisico = card.getAttribute('data-vxc-fisico') === 'true';
          show = show && (isFisico === window.vxcActiveFisico);
        }
        if (show && window.vxcActivePriceMin !== null) {
          var price = parseFloat(card.getAttribute('data-vxc-price'));
          show = show && !isNaN(price) && price >= window.vxcActivePriceMin &&
            (window.vxcActivePriceMax === null || price <= window.vxcActivePriceMax);
        }
        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      var anyFilterActive = window.vxcActiveFisico !== null || window.vxcActivePriceMin !== null;

      /* Bug: Tipo/Precio son filtros 100% client-side (ver comentario de
         arriba) -- collection.products nunca se filtra server-side, así
         que el paginate nativo (snippet product-grid, "1 2 3 4") sigue
         reflejando el total SIN filtrar. Navegar a esas páginas con un
         filtro activo mostraría productos que no cumplen el filtro. Se
         oculta mientras haya un filtro activo y se restaura al sacarlo. */
      document.querySelectorAll('.pagination, .pagination__link').forEach(function (el) {
        if (el.dataset.vxOriginalDisplay === undefined) el.dataset.vxOriginalDisplay = el.style.display;
        el.style.display = anyFilterActive ? 'none' : el.dataset.vxOriginalDisplay;
      });

      /* El conteo mostrado se calcula sobre TODA la colección (usando
         window.vxcAllProducts, que trae todos los productos aunque no
         estén cargados en el DOM todavía), no solo sobre las tarjetas
         que ya están en pantalla -- así el número siempre es real, sin
         importar cuántas páginas se hayan cargado. */
      var trueMatchCount = visibleCount;
      if (anyFilterActive && window.vxcAllProducts) {
        trueMatchCount = window.vxcAllProducts.filter(function (p) {
          var ok = true;
          if (window.vxcActiveFisico !== null) ok = ok && (p.f === window.vxcActiveFisico);
          if (ok && window.vxcActivePriceMin !== null) {
            ok = ok && p.p >= window.vxcActivePriceMin &&
              (window.vxcActivePriceMax === null || p.p <= window.vxcActivePriceMax);
          }
          return ok;
        }).length;
      }

      /* Solo pisar el conteo del servidor (que ya tiene el total real de
         la colección) cuando hay un filtro de Tipo/Precio realmente
         activo. Si no, se restaura el texto original -- si no se
         restaurara, quedaría pegado el último número filtrado incluso
         después de apagar el filtro. */
      var countEl = document.querySelector('.vxc-col-count');
      if (countEl) {
        if (countEl.dataset.vxOriginalText === undefined) countEl.dataset.vxOriginalText = countEl.textContent;
        countEl.textContent = anyFilterActive
          ? trueMatchCount + (trueMatchCount === 1 ? ' producto' : ' productos')
          : countEl.dataset.vxOriginalText;
      }

      /* Botón "Ver X productos" del cajón de filtros (mobile) -- antes
         quedaba pegado en el número con el que cargó la página, sin
         importar qué se tildara adentro del cajón. Ahora refleja en
         vivo lo que el usuario está por aplicar. Mismo cuidado que el
         contador de arriba: sin filtro activo, se restaura el texto
         original en vez de usar el conteo limitado al DOM. */
      var drawerApplyBtn = document.getElementById('vxcDrawerApply');
      if (drawerApplyBtn) {
        if (drawerApplyBtn.dataset.vxOriginalText === undefined) drawerApplyBtn.dataset.vxOriginalText = drawerApplyBtn.textContent;
        drawerApplyBtn.textContent = anyFilterActive
          ? 'Ver ' + trueMatchCount + (trueMatchCount === 1 ? ' producto' : ' productos')
          : drawerApplyBtn.dataset.vxOriginalText;
      }

      var emptyMsg = document.getElementById('vxcClientEmptyMsg');
      if (visibleCount === 0 && anyFilterActive) {
        if (!emptyMsg && cards.length) {
          emptyMsg = document.createElement('div');
          emptyMsg.id = 'vxcClientEmptyMsg';
          emptyMsg.className = 'vxc-empty-state';
          cards[0].parentElement.appendChild(emptyMsg);
        }
        if (emptyMsg) {
          /* Si hay coincidencias reales en la colección pero ninguna está
             cargada en esta página, el mensaje es distinto al de "no hay
             ningún producto que coincida" -- evita el mensaje engañoso. */
          emptyMsg.innerHTML = trueMatchCount > 0
            ? '<p class="vxc-empty-state__title">Hay productos que coinciden, pero no est\u00e1n cargados en esta p\u00e1gina</p><p class="vxc-empty-state__text">Segu\u00ed bajando para cargar m\u00e1s productos, o ajust\u00e1 los filtros.</p>'
            : '<p class="vxc-empty-state__title">No hay productos con estos filtros</p><p class="vxc-empty-state__text">Prob\u00e1 sacando alguno de los filtros de tipo o precio.</p>';
          emptyMsg.style.display = '';
        }
      } else if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }
    };

    document.querySelectorAll('input[name="vxc-tipo"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        var fisico = radio.getAttribute('data-fisico') === 'true';
        if (window.vxcActiveFisico === fisico) {
          window.vxcActiveFisico = null;
          radio.checked = false;
        } else {
          window.vxcActiveFisico = fisico;
        }
        window.vxcApplyClientFilters();
      });
    });

    document.querySelectorAll('input[name="vxc-price"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        var min = parseFloat(radio.getAttribute('data-min'));
        var maxAttr = radio.getAttribute('data-max');
        var max = maxAttr === '' ? null : parseFloat(maxAttr);
        if (window.vxcActivePriceMin === min && window.vxcActivePriceMax === max) {
          window.vxcActivePriceMin = null;
          window.vxcActivePriceMax = null;
          radio.checked = false;
        } else {
          window.vxcActivePriceMin = min;
          window.vxcActivePriceMax = max;
        }
        window.vxcApplyClientFilters();
      });
    });

    /* Chips de filtros activos: quitar UNO al hacer clic en la X */
    document.querySelectorAll('.vxc-chip').forEach(function(chip) {
      chip.addEventListener('click', function() {
        var tag = chip.getAttribute('data-tag');
        var remaining = getActiveTags().filter(function(t) { return t !== tag; });
        window.location = buildUrl(remaining);
      });
    });
  })();

  /* ── Scroll estático: solo el grid hace scroll en DESKTOP ───
     En mobile el scroll es natural (página completa).
     Evita conflicto con animación del header en desktop. */
  (function() {
    var mainEl = document.getElementById('vxcMain');
    if (!mainEl) return;
    function setGridHeight() {
      if (window.innerWidth <= 989) {
        mainEl.style.height = '';
        mainEl.style.overflowY = '';
        mainEl.style.overflowX = '';
        return;
      }
      var headerH = 92;
      var available = window.innerHeight - headerH;
      mainEl.style.height = available + 'px';
      mainEl.style.overflowY = 'auto';
      /* No poner overflowX:hidden — puede capturar clicks del cart-drawer */
      mainEl.style.overflowX = 'visible';
    }
    setGridHeight();
    window.addEventListener('resize', setGridHeight, { passive: true });
    var rl = document.querySelector('results-list');
    if (rl && window.innerWidth > 989) {
      rl.setAttribute('scroll-container', '#vxcMain');
    }
  })();

  /* ── Sort: redirigir al cambiar orden ────────────────────── */
  var sortEl = document.getElementById('vxcSort');
  if (sortEl) {
    sortEl.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortEl.value);
      window.location.href = url.toString();
    });
  }

  /* ── Drawer filtros mobile ───────────────────────────────── */
  var toggle      = document.getElementById('vxcFilterToggle');
  var drawer      = document.getElementById('vxcFilterDrawer');
  var drawerBody  = document.getElementById('vxcDrawerBody');
  var overlay     = document.getElementById('vxcDrawerOverlay');
  var closeBtn    = document.getElementById('vxcDrawerClose');
  var applyBtn    = document.getElementById('vxcDrawerApply');
  var clearDrawer = document.getElementById('vxcDrawerClear');
  var sidebar     = document.querySelector('.vxc-sidebar');

  /* Mover el contenido del sidebar al drawer en mobile */
  function syncDrawerContent() {
    if (!sidebar || !drawerBody) return;
    if (window.innerWidth < 990) {
      /* Mover al drawer si no está ya ahí */
      if (drawerBody.children.length === 0) {
        Array.from(sidebar.children).forEach(function(child) {
          drawerBody.appendChild(child);
        });
      }
    } else {
      /* Devolver al sidebar si no está ya ahí */
      if (sidebar.children.length === 0 && drawerBody.children.length > 0) {
        Array.from(drawerBody.children).forEach(function(child) {
          sidebar.appendChild(child);
        });
      }
    }
  }

  syncDrawerContent();
  window.addEventListener('resize', syncDrawerContent, { passive: true });

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.removeAttribute('hidden');
    overlay.classList.add('is-open');
    /* Usar el mecanismo nativo de Horizon en lugar de body.style.overflow
       para no conflictuar con el cart-drawer ni el header */
    document.documentElement.setAttribute('vxc-filter-lock', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var firstBtn = drawer.querySelector('button, input, select, a');
    if (firstBtn) setTimeout(function() { firstBtn.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.setAttribute('hidden', '');
    overlay.classList.remove('is-open');
    document.documentElement.removeAttribute('vxc-filter-lock');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle)   toggle.addEventListener('click', openDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (applyBtn) applyBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) {
      closeDrawer();
      if (toggle) toggle.focus();
    }
  });

  /* ── Limpiar filtros ─────────────────────────────────────── */
  function clearAllFilters() {
    /* Los filtros acá viven como segmento de ruta (/coleccion/tag1+tag2),
       no como query params filter.* -- volver a los primeros 3 segmentos
       (['', 'collections', 'slug']) es lo que realmente los limpia. */
    var base = window.location.pathname.split('/').slice(0, 3).join('/');
    window.location.href = base;
  }

  var clearDesktop = document.getElementById('vxcClearFilters');
  if (clearDesktop) clearDesktop.addEventListener('click', clearAllFilters);
  if (clearDrawer)  clearDrawer.addEventListener('click', function() { clearAllFilters(); });

  /* Mostrar botón Limpiar si hay filtros activos (segmento de tags presente) */
  var pathParts = window.location.pathname.split('/');
  var hasFilters = pathParts.length > 3 && pathParts[3] !== '';
  if (hasFilters && clearDesktop) {
    clearDesktop.classList.add('visible');
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabajos-vexial"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.getElementById('vxProyectoModal');
  var modalContent = document.getElementById('vxProyectoModalContent');
  if (!modal || !modalContent) return;

  var lastFocused = null;

  function openProyecto(id) {
    var data = document.getElementById(id);
    if (!data) return;
    modalContent.innerHTML = data.innerHTML;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lastFocused = document.activeElement;
    var closeBtn = modal.querySelector('.vx-proyecto-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeProyecto() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    modalContent.innerHTML = '';
    if (lastFocused) lastFocused.focus();
  }

  document.querySelectorAll('[data-vx-open-proyecto]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openProyecto(btn.getAttribute('data-vx-open-proyecto'));
    });
  });

  document.querySelectorAll('[data-vx-close-proyecto]').forEach(function (el) {
    el.addEventListener('click', closeProyecto);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeProyecto();
  });
})();

/* Puntos de paginación mobile -- IIFE aparte, no depende de que
   exista la ventana flotante (si esa falla por lo que sea, los
   puntos siguen funcionando igual). */
(function () {
  var grid = document.querySelector('.vx-trabajos-grid');
  var dotsWrap = document.getElementById('vxTrabajosDots');
  if (!grid || !dotsWrap) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.vx-trabajo-card'));
  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.vx-trabajos-dot'));
  if (!cards.length || !dots.length) return;

  function setActiveDot(index) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    cards.forEach(function (card, i) {
      card.classList.toggle('is-active', i === index);
    });
  }

  /* Clic en un punto -> scrollea hasta esa tarjeta */
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  /* Que tarjeta esta mas visible mientras se scrollea -> ese punto se activa */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          var idx = cards.indexOf(entry.target);
          if (idx > -1) setActiveDot(idx);
        }
      });
    }, { root: grid, threshold: [0.6] });
    cards.forEach(function (card) { observer.observe(card); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
